export default __webpack_public_path__ + "static/media/2024-oftalmologie-1.81b1c3f3.jpg";